export default {
  common: {
    unexpectedError: 'An unexpected error occurred',
    unexpectedErrorWithDetails: 'An unexpected error occurred: {error}'
  },
  menu: {
    appName: 'Housebook User'
  },
  login: {
    title: 'Login',
    email: 'E-mail',
    password: 'Password',
    performLogin: 'Login',
    resetPassword: 'Forgot password?',
    invalidCredentialsError: 'Invalid username or password'
  },
  resetPassword: {
    title: 'Reset password',
    email: 'E-mail',
    description: 'Enter the E-mail address of the account for which you want to reset the password.',
    performReset: 'Reset',
    performLogin: 'Login',
    successMsg: 'Shortly you will receive an E-mail at the specified address. Follow the steps in that mail to finalize resetting your password.'
  },
  edit: {
    title: 'Edit your User data',
    firstName: 'First name',
    lastName: 'Last name',
    language: 'Language',
    phone: 'Phone',
    country: 'Country',
    zip: 'ZIP code',
    city: 'City',
    street: 'Street',
    streetNumber: 'Street number',
    performSave: 'Save',
    succeeded: 'Use data has been saved!'
  },
  blackboard: {
    title: 'Blackboard',
    performShow: 'Show'
  },
  onboarding: {
    signupTitle: 'Welcome to Housebook!',
    signupDescription: 'You have been invited to create a Housebook account and join a Housebook organization. Please accept the following terms in order to complete the signup and start using Housebook.',
    invitationTitle: 'Housebook Invitation',

    terms: 'Please read the Housebook terms of service carefully:',
    termsUrl: 'https://housebook-solutions.com/en/agb/',
    termsLink: 'Terms of Service',
    acceptTermsOfService: 'I have read and accept the terms of service',

    invitation: 'You have been invite to join the Housebook organization {organizationName}.',
    acceptInvitation: 'I accept the invitation',
    succeededTitle: 'Completed successfully!',
    nextSteps: 'Your next steps with Housebook:',
    editAccount: 'Edit your account data',
    editAccountButton: 'Edit account',
    installApp: 'Install the Housebook app on your smartphone',
    openHousebookControl: 'Manage projects with Housebook Control on your computer',
    openHousebookControlButton: 'Open Housebook Control',

    iosInstallTitle: 'Available on the AppStore',
    androidInstallTitle: 'Get it on Google Play',
    iosInstallBadgeUrl: 'https://linkmaker.itunes.apple.com/assets/shared/badges/en-us/appstore-lrg.svg',
    androidInstallBadgeUrl: 'https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png',
    iosInstallUrl: 'https://itunes.apple.com/us/app/housebook-app/id1109844386?mt=8&at=10l6Xd&ct=ivtj5dzhg600xkod01g9a',
    androidInstallUrl: 'https://play.google.com/store/apps/details?id=at.bitstudios.housebook&utm_source=global_co&utm_medium=prtnr&utm_content=Mar2515&utm_campaign=PartBadge&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&hl=en',

    credentials: 'Choose your password for your Housebook username {username}.',
    username: 'Username',
    password: 'Password',
    passwordRepeated: 'Password (repeat)',
    enterPasswordMsg: 'Enter a password with at least 7 characters.',
    repeatPasswordMsg: 'Please repeat the password.',
    passwordsMatchMsg: 'Passwords match!',

    commit: 'Commit',

    invitationNotFoundError: 'The invitation does not exist',
    invitationExpiredError: 'The invitation is expired',
    invitationAlreadyAcceptedError: 'The invitation already has been accepted',
    requiresLoginError: 'You must be logged in',
    invalidUserError: 'You are not the invited user'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/en.js